import { render, staticRenderFns } from "./BusinessDepartment.vue?vue&type=template&id=f5e14bbc&scoped=true&"
import script from "./BusinessDepartment.vue?vue&type=script&lang=js&"
export * from "./BusinessDepartment.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDepartment.vue?vue&type=style&index=0&id=f5e14bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e14bbc",
  null
  
)

export default component.exports